import React, { useState, useEffect } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  CardText,
  CardHeader,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import GamesTicketsTable from "./Table"
import { FiltersCard } from "components/Common/FiltersCard"
import axios from "axios"
import { API_URL, sitename } from "../../../constants/constants"

import "../../../assets/table.css"
import TableLoader from "../../../components/Common/TableLoader"
import moment from "moment"

const Index = () => {
  const [item, setItem] = useState("All")
  const [gameReportsData, setGameReportsData] = useState([])
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"))
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"))
  const [type, setType] = useState("Pragmatic")
  const [totalUniquePlayers, setTotalUniquePlayers] = useState(0)
  const [totalStakes, setTotalStakes] = useState(0)
  const [totalGGR, setTotalGGR] = useState(0)
  const [RTP, setRTP] = useState(0)
  const [total, setTotal] = useState(0)
  const [nextPageUrl, setNextPageUrl] = useState("")
  const [prevPageUrl, setPrevPageUrl] = useState("")
  const [callUrl, setCallUrl] = useState("")
  const [loadingMessage, setLoadingMessage] = useState("1")
  const [currentPage, setCurrentPage] = useState(1)
  const [lastPage, setLastPage] = useState(0)
  const [data, setData] = useState([])

  const optionsType = [
    { label: "Pragmatic", value: "Pragmatic" },
    { label: "TurboGames", value: "TurboGames" },
    { label: "Spribe Games", value: "SpribeGames" },
    { label: "BigWins", value: "BigWins" },
  ]

  useEffect(() => {
    call()
  }, [toDate, fromDate, item, type])

  const call = () => {
    setLoadingMessage("1")
    axios({
      method: "get",
      url: `${API_URL}/admin/reports/game-reports?to=${toDate}&from=${fromDate}&type=${item}&item=${type}`,
    })
      .then(function (response) {
        const data = response?.data?.data?.data || []
        setGameReportsData(data)

        // Calculate the total number of unique players
        const totalPlayers = data.reduce(
          (total, game) => total + game.unique_players,
          0
        )
        setTotalUniquePlayers(totalPlayers)

        // // Calculate total stakes and total GGR
        const stakes = data.reduce((total, game) => total + game.total_stake, 0)
        setTotalStakes(stakes)

        const GGR = data.reduce((total, game) => total + game.GGR, 0)
        setTotalGGR(GGR)

        // // Calculate RTP
        const RTPValue = stakes !== 0 ? ((stakes - GGR) / stakes) * 100 : 0
        setRTP(RTPValue)
        setTotal(response?.data?.data?.total)
        setNextPageUrl(response?.data?.data?.next_page_url)
        setCurrentPage(response?.data?.data?.current_page)
        setLastPage(response?.data?.data?.last_page)

        setLoadingMessage("0")
      })
      .catch(function (error) {
        console.error("Error fetching game reports data:", error)
      })
  }
  $(document)
    .off("click")
    .on("click", "ul.pagination li a", function (e) {
      e.preventDefault()
      e.stopPropagation()
      setLoadingMessage("1")

      var page = $(this).text()
      if (page == ">") {
        if (currentPage < lastPage) {
          console.log("yes")
          page = currentPage + 1
        }
      }
      if (page == ">>") {
        page = lastPage
      }
      if (page == "<") {
        if (currentPage > 1) {
          page = currentPage - 1
        }
      }

      axios({
        method: "get",
        url: `${API_URL}/admin/reports/game-reports?page=${page}&to=${toDate}&from=${fromDate}&type=${item}&item=${type}`,
      })
        .then(function (response) {
          const data = response?.data?.data?.data || []
          setGameReportsData(data)

          // Calculate the total number of unique players
          const totalPlayers = data.reduce(
            (total, game) => total + game.unique_players,
            0
          )
          setTotalUniquePlayers(totalPlayers)

          // // Calculate total stakes and total GGR
          const stakes = data.reduce(
            (total, game) => total + game.total_stake,
            0
          )
          setTotalStakes(stakes)

          const GGR = data.reduce((total, game) => total + game.GGR, 0)
          setTotalGGR(GGR)

          // // Calculate RTP
          const RTPValue = stakes !== 0 ? ((stakes - GGR) / stakes) * 100 : 0
          setRTP(RTPValue)
          setTotal(response?.data?.data?.total)
          setNextPageUrl(response?.data?.data?.next_page_url)
          setPrevPageUrl(response?.data?.data?.prev_page_url)
          setLastPage(response?.data?.data?.last_page)
          setCurrentPage(response?.data?.data?.current_page)
          var current = response?.data?.data?.current_page
          setLoadingMessage("0")

          $("ul.pagination li").removeClass("active")
          $('ul.pagination li[title="' + current + '"]').addClass("active")
          if (current > 1) {
            $(
              '.pagination.react-bootstrap-table-page-btns-ul li[title="first page"]'
            ).removeClass("disabled")
            $(
              '.pagination.react-bootstrap-table-page-btns-ul li[title="previous page"]'
            ).removeClass("disabled")
          } else {
            $(
              '.pagination.react-bootstrap-table-page-btns-ul li[title="first page"]'
            ).addClass("disabled")
            $(
              '.pagination.react-bootstrap-table-page-btns-ul li[title="previous page"]'
            ).addClass("disabled")
          }
        })
        .catch(function (response) {})
    })

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Admin" breadcrumbItem="Games Reports" />
        </Container>
        <Row>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">
                Total Users
              </CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {totalUniquePlayers.toLocaleString()}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">
                Total Stakes
              </CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {totalStakes.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">
                GGR
              </CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText className="font-size-16">
                    {totalGGR.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
          <Col lg={3}>
            <Card>
              <CardHeader className="bg-transparent border-bottom text-uppercase">
                RTP
              </CardHeader>
              <CardBody>
                <blockquote className="card-blockquote mb-0">
                  <CardText
                    className="font-size-16"
                    style={{ color: RTP < 100 ? "green" : "red" }}
                  >
                    {RTP.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    %
                  </CardText>
                </blockquote>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <FiltersCard
          item={item}
          setItem={setItem}
          optionsType={optionsType}
          fromDate={fromDate}
          toDate={toDate}
          setToDate={d => setToDate(d)}
          setFromDate={d => setFromDate(d)}
          notDisplayFilter={true}
          call={() => {
            call()
          }}
          setType={setType}
          showType={true}
          type={type}
          hideShowType={false}
        />
        <GamesTicketsTable
          data={gameReportsData}
          item={item}
          type={type}
          call={() => {
            call()
          }}
          toDate={toDate}
          fromDate={fromDate}
          loadingMessage={loadingMessage}
          setLoadingMessage={setLoadingMessage}
          setTotal={setTotal}
          total={total}
          currentPage={currentPage}
          setCallUrl={setCallUrl}
          setPrevPageUrl={setPrevPageUrl}
          prevPageUrl={prevPageUrl}
          nextPageUrl={nextPageUrl}
          setNextPageUrl={setNextPageUrl}
        />
      </div>
    </React.Fragment>
  )
}

export default withRouter(Index)
